/**
 * Admin email configuration
 * Shared between frontend and backend
 */

export const ADMIN_EMAILS = [
  'david@zapt.ai',
  'phil@zapt.ai',
];

// Email address that receives admin notification emails
export const RECEIVE_ADMIN_EMAILS = 'david@zapt.ai';

// Emails that receive customer message notifications (can be multiple)
export const MESSAGING_NOTIFICATION_EMAILS = ['david@zapt.ai', 'phil@zapt.ai'];

// For CommonJS compatibility (Node.js backend)
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    ADMIN_EMAILS,
    RECEIVE_ADMIN_EMAILS,
    MESSAGING_NOTIFICATION_EMAILS
  };
}



